import React, { useEffect } from 'react';
import Script from 'next/script';
import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import shouldLoadDyna from '@gc-npm/core.utils.should-load-dyna';
import RouteHandler from '@gc-npm/core.route-handler';
import { initOpenTelemetry, initPusSub, sendPubSubMessage, getScreenTypeByWidth} from '@/utils';
import { actions as uiActions } from '@/reducers/ui';
import { syncLocalSession } from '@/utils/local-session';

import Saam from '@gc-npm/core.scripts.saam';
import OneTrust from '@gc-npm/components.one-trust-x';
import ErrorBoundary from '@/component/error-boundary';
import { wrapper } from 'store';
import '@/styles/globals.scss';
import '@/styles/fonts.scss';
import '@/styles/colors.scss';
import '@/styles/grid.scss';
import '@/styles/skeleton.scss';
// IMPORTS
/* [STYLES] begins */
/* [STYLES] ends */
import '@/styles/card.scss';
import '@/styles/cms-block.cms-superbanner.scss';
import '@/styles/cms-block.cms-superbanner.video-component.scss';
import '@/styles/image-slider.scss';
import '@/styles/tv-card.scss';
import '@/styles/product-modal.scss';
import '@/styles/tv-filters.scss';

const Dyna = dynamic(() => import('@gc-npm/core.scripts.dyna'));


const App = ({ Component, pageProps }) => {
  // //Initializing OpenTelemetry
  if (process.env.NEXT_PUBLIC_ENV_NAME === "prod") {
    initOpenTelemetry(); 
  }
  initPusSub()
  // sendPubSubMessage();
  const dispatch = useDispatch();
  const Modal = useSelector((state) => state.modals.Modal);

  useEffect(() => {
    syncLocalSession();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const setScreenType = () => {
      dispatch(uiActions.setScreenType(getScreenTypeByWidth(window.innerWidth)));
    };
    setScreenType();
    let debounceTimer;
    const handleResize = () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(setScreenType, 200);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.clearTimeout(debounceTimer);
    };
  }, [dispatch]);

  return (
    <>
      <Script
        src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID}`}
        strategy="lazyOnload"
      />
      <RouteHandler />
      <ErrorBoundary>
        <Component {...pageProps} />
        {Modal && Modal}
        <OneTrust />
      </ErrorBoundary>
      <Saam />
      {shouldLoadDyna() && <Dyna />}
      {/* APP DELIMITER */}
    </>
  );
};

export default wrapper.withRedux(App);
